import { ApiError } from '@accredible-frontend-v2/models';

export interface WebSocketProgressMessage<T> {
  kind: WebSocketProgressKind;
  status: WebSocketProgressStatus;
  progress?: number;
  data?: T;
  error?: ApiError;
}

export enum WebSocketProgressStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  COMPLETED_WITH_ERRORS = 'completed_with_errors',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export enum WebSocketProgressKind {
  CREDENTIALS_BULK_OPERATION = 'credentials_bulk_operation',
  PATHWAY_CSV_EXPORT = 'pathway_csv_export',
  CREDENTIALS_CSV_ANALYSIS = 'credentials_csv_analysis',
  CREDENTIALS_CSV_IMPORT = 'credentials_csv_import',
  ELIGIBLE_RECIPIENTS_BULK_OPERATION = 'pathway_eligible_users_bulk_operation',
  SKILL_FRAMEWORK_VALIDATION = 'skill_framework_validation',
  SKILL_FRAMEWORK_VERSION_DIFF = 'skill_framework_version_diff',
  SKILL_FRAMEWORK_GROUP_UPDATE = 'skill_framework_group_update',
}
